<div *ngIf="isLogin" class="p-card-to-use js-card-to-use">
  <div *ngIf="isSp && !cardChangeMode" class="p-card-to-use__change is is-open u-display-block-sp">
    <div class="p-card-to-use__change-item">
      <!-- 新しいカード -->
      <div *ngIf="selectedCard === 'other'" class="p-card-to-use__change-title">
        <span class="p-card-to-use__change-title-label" [innerHTML]="'label.newCreditCard' | staticMsg"></span>
        <span class="u-visually-hidden" [innerHTML]="'labbel.cardSelected' | staticMsg"></span>
      </div>
      <!-- いつもの情報のクレジットカード１-->
      <div *ngIf="selectedCard === 'corporatePaymentCard1' && creditCardName1" class="p-card-to-use__change-title">
        <span class="p-card-to-use__change-title-label" [innerHTML]="creditCardName1"></span>
        <span class="u-visually-hidden" [innerHTML]="creditCardName1"></span>
      </div>
      <!-- いつもの情報のクレジットカード２-->
      <div *ngIf="selectedCard === 'corporatePaymentCard2' && creditCardName2" class="p-card-to-use__change-title">
        <span class="p-card-to-use__change-title-label" [innerHTML]="creditCardName2"></span>
        <span class="u-visually-hidden" [innerHTML]="creditCardName2"></span>
      </div>

      <div class="p-card-to-use__change-btn">
        <button
          id="corporate-card-to-use-button1"
          class="c-btn-tertiary c-btn-tertiary--xs"
          (click)="changeSelectedCardSp()"
        >
          <span class="c-btn-tertiary__text" [innerHTML]="'label.detailsLinkToChangeCard' | staticMsg"></span>
        </button>
      </div>
    </div>
    <span class="u-visually-hidden"> card-to-use-menu-button</span>
  </div>
  <div *ngIf="cardChangeMode || !isSp" class="p-card-to-use__menu">
    <div
      [ngClass]="{
        'p-card-to-use__menu-item': true,
        'p-card-to-use__menu-item--selected': selectedCard === 'other'
      }"
    >
      <div class="p-card-to-use__menu-title">
        <div class="p-card-to-use__menu-title-label" [innerHTML]="'label.newCreditCard' | staticMsg"></div>
      </div>
      <div class="p-card-to-use__menu-btn">
        <div *ngIf="selectedCard === 'other'" class="p-card-to-use__menu-btn-mark">
          <img
            src="assets/images/icon_check_primary_20.svg"
            width="20"
            height="20"
            [attr.alt]="'reader.selecting' | staticMsg"
          />
        </div>
        <button
          id="anabiz-card-to-use-menu-button1"
          class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
          [attr.aria-label]="'label.newCreditCard' | staticMsg"
          (throttleClick$)="selectedCreditCardChange('other')"
          aswThrottleClick
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"> </span>
        </button>
      </div>
    </div>
    <div
      *ngIf="creditCardName1"
      [ngClass]="{
        'p-card-to-use__menu-item': true,
        'p-card-to-use__menu-item--selected': selectedCard === 'corporatePaymentCard1'
      }"
    >
      <div class="p-card-to-use__menu-title">
        <div class="p-card-to-use__menu-title-label" [innerHTML]="creditCardName1"></div>
      </div>
      <div class="p-card-to-use__menu-btn">
        <div *ngIf="selectedCard === 'corporatePaymentCard1'" class="p-card-to-use__menu-btn-mark">
          <img
            src="assets/images/icon_check_primary_20.svg"
            width="20"
            height="20"
            [attr.alt]="'reader.selecting' | staticMsg"
          />
        </div>
        <button
          id="select-anabiz-corporate-card1"
          class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
          aria-label="selectCreditCardName1"
          (throttleClick$)="selectedCreditCardChange('corporatePaymentCard1')"
          aswThrottleClick
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"> </span>
        </button>
      </div>
    </div>
    <div
      *ngIf="creditCardName2"
      [ngClass]="{
        'p-card-to-use__menu-item': true,
        'p-card-to-use__menu-item--selected': selectedCard === 'corporatePaymentCard2'
      }"
    >
      <div class="p-card-to-use__menu-title">
        <div class="p-card-to-use__menu-title-label" [innerHTML]="creditCardName2"></div>
      </div>
      <div class="p-card-to-use__menu-btn">
        <div *ngIf="selectedCard === 'corporatePaymentCard2'" class="p-card-to-use__menu-btn-mark">
          <img
            src="assets/images/icon_check_primary_20.svg"
            width="20"
            height="20"
            [attr.alt]="'reader.selecting' | staticMsg"
          />
        </div>
        <button
          id="anabiz-card-to-use-menu-button3"
          class="p-card-to-use__menu-btn-select c-btn-primary c-btn-primary--xs"
          aria-label="selectCreditCardName2"
          (throttleClick$)="selectedCreditCardChange('corporatePaymentCard2')"
          aswThrottleClick
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.cardSelect' | staticMsg"> </span>
        </button>
      </div>
    </div>
  </div>
</div>
